import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Check } from "@mui/icons-material";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import messages from "../../../assets/locale/messages";
import { BlueBoxBgIcon } from "../../../utils/Icons";
import { approveProductRequest } from "../../../store/Products/actions";

const ApproveProduct = ({ productId, productName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const lang = useSelector((state) => state.locale.lang);
  const {
    products: { reviewProduct }
  } = messages[lang];

  const [openModal, setOpenModal] = useState(false);

  const handleApproveProduct = () => {
    dispatch(approveProductRequest({ id: productId, navigate }));
    setOpenModal(false);
  };

  return (
    <div className="approve-request-modal">
      <Button
        label={
          <span className="d-flex align-items-center">
            <Check className="me-0 me-md-2" />
            <span>{reviewProduct.approve}</span>
          </span>
        }
        success
        onClick={() => setOpenModal(true)}
      />
      {openModal && (
        <Modal
          open={openModal}
          handleClose={() => setOpenModal(false)}
          title={
            <>
              {reviewProduct.approve} {productName}
            </>
          }
          content={reviewProduct.approveConfirmMsg}
          confirmBtnTxt={reviewProduct.approve}
          cancelBtnTxt={reviewProduct.cancel}
          icon={<BlueBoxBgIcon />}
          handleConfirm={handleApproveProduct}
          handleCancel={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};

export default ApproveProduct;

ApproveProduct.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  productName: PropTypes.string.isRequired
};
